import addStartupScript from './events/addStartupScript';
import setupObserver, { setupWithoutObserver } from './media/observer';

const trustpilotScriptSrc = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

function showTrustPilotWidget() {
  const trustpilotScript = document.createElement('script');
  trustpilotScript.src = trustpilotScriptSrc;
  if(window.trustpilotLazyLoading) trustpilotScript.async = true;
  document.body.appendChild(trustpilotScript);
}

addStartupScript(function() {
  const trustpilotScript = document.querySelector('script[src="`${trustpilotScriptSrc}`"]');

  if(!trustpilotScript) {
    const trustpilotAnchorTag = document.querySelectorAll('a[href="https://www.trustpilot.com/review/varsitytutors.com"]');
    if(window.trustpilotLazyLoading) {
      setupObserver(trustpilotAnchorTag, showTrustPilotWidget);
    } else {
      setupWithoutObserver(trustpilotAnchorTag, showTrustPilotWidget);
    }
  }
});
